import { useCallback, useEffect } from 'react'
import useOnboard, { connectWallet } from '@/hooks/wallets/useOnboard'

// Función para gestionar la visibilidad del logo móvil
const toggleMobileLogoVisibility = (isConnecting: boolean) => {
  // Selecciona todos los elementos con la clase logoMobile
  const logoElements = document.querySelectorAll('.logoMobile')

  logoElements.forEach((el) => {
    // Si está conectando (modal abierto), oculta el logo
    if (isConnecting) {
      el.setAttribute('style', 'display: none !important')
    } else {
      // Si el modal está cerrado, restaura la visibilidad (respetando media queries)
      el.removeAttribute('style')
    }
  })
}

const useConnectWallet = () => {
  const onboard = useOnboard()

  // Efecto para observar cambios en el DOM y detectar el modal de web3-onboard
  useEffect(() => {
    // Crear un observer para detectar cuando se añade el modal al DOM
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          // Buscar elementos que indiquen que el modal está abierto
          const modalOpen =
            document.querySelector('.w3o-modal') !== null ||
            document.querySelector('[class*="w3o"]') !== null ||
            document.querySelector('.ReactModal__Overlay') !== null

          // Alternar la visibilidad del logo según la presencia del modal
          toggleMobileLogoVisibility(modalOpen)
        }
      }
    })

    // Observar cambios en el body
    observer.observe(document.body, { childList: true, subtree: true })

    return () => {
      observer.disconnect()
      // Asegurarse de restaurar el logo cuando el componente se desmonte
      toggleMobileLogoVisibility(false)
    }
  }, [])

  return useCallback(() => {
    if (!onboard) {
      return Promise.resolve(undefined)
    }

    // Ocultar el logo antes de abrir el modal
    toggleMobileLogoVisibility(true)

    return connectWallet(onboard).then((result) => {
      // Si el modal se cierra sin seleccionar wallet, restaurar el logo
      if (!result || result.length === 0) {
        toggleMobileLogoVisibility(false)
      }
      return result
    })
  }, [onboard])
}

export default useConnectWallet
